import React from 'react'
import intro from '../assets/me.png'

const Intro = () => {
  return (
    <div className='flex-col md:flex-row pt-7 md:pt-0 md:w-full h-auto md:h-[450px] flex justify-around items-center text-white'>
      <div>
    <img className='w-60 md:w-96' src={intro} alt="me" />
      </div>
      <div className='flex flex-col items-start ml-6 md:m-0 md:block'>
        <div className="name text-yellow-500 text-2xl font-extrabold relative rotate-[345deg] left-[-10px] top-[-50px]">hi, I'm Krishna!</div>
        <p className='text-6xl font-bold'>Front End <br /> Developer</p>
        <p className='my-4 text-3xl px-[5px]'>12th Grade student from India. </p>
      </div>
    </div>
  )
}

export default Intro
